<div class="wrapper" [ngClass]="{ 'wrapper--configurator': isConfigurator }">
    <mg-header *ngIf="!isConfigurator" [useGreenNav]="useGreenNav"></mg-header>

    <div class="page-wrapper" [ngClass]="{ 'with-top-padding': !isConfigurator }">
        <ng-content></ng-content>
    </div>

    <mg-footer *ngIf="!isConfigurator && !withoutFooter"></mg-footer>
</div>
